<div class="applied-filter-bar mb-3" *ngIf="(filterState$ | async) as filterState">
  <div class="card applied-filter-card flex items-center gap-2 flex-wrap" *ngIf="hasActiveFilters(filterState)" style="padding: 10px;">    
     <!-- <ng-container *ngIf="filterState.selectedBrands?.length > 0">
      <span class="text-xs text-500 uppercase pt-2">Brands:</span>
      <p-chip 
        *ngFor="let brand of filterState.selectedBrands"
        [label]="brand.name" 
        [removable]="true"
        (onRemove)="removeBrand(brand.id)"
        styleClass="brand-chip"
        [pTooltip]="brand.name"
        tooltipPosition="bottom" />
    </ng-container>
     -->
<!-- 
    <ng-container *ngIf="filterState.selectedHotels?.length > 0">
      <span class="text-xs text-500 uppercase pt-2">Hotels:</span>
      <p-chip 
        *ngFor="let hotel of filterState.selectedHotels"
        [label]="hotel.name" 
        [removable]="true"
        (onRemove)="removeHotel(hotel.id)"
        styleClass="hotel-chip"
        [pTooltip]="hotel.name"
        tooltipPosition="bottom" />
    </ng-container> -->

    <ng-container *ngIf="filterState.selectedEnterprises.length > 0">
      <span class="text-xs text-500 uppercase pt-0-7rem">Enterprises:</span>
      <p-chip 
        *ngFor="let enterprise of filterState.selectedEnterprises.slice(0, 2)"
        [label]="enterprise.name" 
        [removable]="true"
        (onRemove)="removeEnterprise(enterprise.id)"
        styleClass="enterprise-chip"
        [pTooltip]="enterprise.name"
        tooltipPosition="bottom" />
      <p-chip 
        *ngIf="hasRemainingItems(filterState, 'enterprises')"
        [label]="getRemainingCount(filterState, 'enterprises')"
        [removable]="false"
        styleClass="enterprise-chip count-chip" />
    </ng-container>

    <ng-container *ngIf="filterState.selectedOwners.length > 0">      
      <span class="text-xs text-500 uppercase pt-0-7rem">Owners:</span>
      <p-chip 
        *ngFor="let owner of filterState.selectedOwners.slice(0, 2)"
        [label]="owner.groupName" 
        [removable]="true"
        (onRemove)="removeOwner(owner.id)"
        styleClass="owner-chip"
        [pTooltip]="owner.description || owner.groupName"
        tooltipPosition="bottom" />
      <p-chip 
        *ngIf="hasRemainingItems(filterState, 'owners')"
        [label]="getRemainingCount(filterState, 'owners')"
        [removable]="false"
        styleClass="owner-chip count-chip" />
    </ng-container>


    <ng-container *ngIf="filterState.selectedRegions.length > 0">
      <span class="text-xs text-500 uppercase pt-0-7rem">Regions:</span>
      <p-chip 
        *ngFor="let region of filterState.selectedRegions.slice(0, 2)"
        [label]="region.regionName" 
        [removable]="true"
        (onRemove)="removeRegion(region.id)"
        styleClass="region-chip"
        [pTooltip]="region.regionName"
        tooltipPosition="bottom" />
      <p-chip 
        *ngIf="hasRemainingItems(filterState, 'regions')"
        [label]="getRemainingCount(filterState, 'regions')"
        [removable]="false"
        styleClass="region-chip count-chip" />
    </ng-container>

    <!-- Clear All Button -->
    <p-button 
      label="Clear All" 
      icon="pi pi-times" 
      severity="secondary" 
      text
      size="small"
      (onClick)="clearAllFilters()"
      styleClass="ml-auto">
    </p-button>
    

  </div>
</div>
